var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "ic-form__r-06" },
    [
      _c(
        "FormWrapper",
        { attrs: { validator: _vm.$v.form } },
        [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-4" }),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-8" }, [
              _c("p", {
                staticClass: "mt-3 alert alert-warning",
                domProps: { innerHTML: _vm._s(_vm.$t("form_r06_introtext")) },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("IcFormContactName", {
            model: {
              value: _vm.form.name,
              callback: function ($$v) {
                _vm.$set(_vm.form, "name", $$v)
              },
              expression: "form.name",
            },
          }),
          _vm._v(" "),
          _c("IcFormContactEmail", {
            attrs: { withAgreement: true },
            on: {
              "update:agreement": function ($event) {
                _vm.form.emailAgreement = $event
              },
              "update:pollAgreement": function ($event) {
                _vm.form.pollAgreement = $event
              },
            },
            model: {
              value: _vm.form.email,
              callback: function ($$v) {
                _vm.$set(_vm.form, "email", $$v)
              },
              expression: "form.email",
            },
          }),
          _vm._v(" "),
          _c("IcFormContactPhone", {
            model: {
              value: _vm.form.phone,
              callback: function ($$v) {
                _vm.$set(_vm.form, "phone", $$v)
              },
              expression: "form.phone",
            },
          }),
          _vm._v(" "),
          _c("IcFormContactAddress", {
            model: {
              value: _vm.form.address,
              callback: function ($$v) {
                _vm.$set(_vm.form, "address", $$v)
              },
              expression: "form.address",
            },
          }),
          _vm._v(" "),
          _c("h3", [_vm._v("Wiadomość")]),
          _vm._v(" "),
          _c("IcFormContactMessage", {
            model: {
              value: _vm.form.message,
              callback: function ($$v) {
                _vm.$set(_vm.form, "message", $$v)
              },
              expression: "form.message",
            },
          }),
          _vm._v(" "),
          _c("IcFormContactFiles", {
            model: {
              value: _vm.form.files,
              callback: function ($$v) {
                _vm.$set(_vm.form, "files", $$v)
              },
              expression: "form.files",
            },
          }),
          _vm._v(" "),
          _c("IcFormAgreements", {
            attrs: {
              text: false,
              header: false,
              modal: true,
              name: "agreement",
              is_visible: false,
              value: true,
              label: _vm.$t("label_agreement_checkbox"),
              content: "form_agreement_r06",
            },
            model: {
              value: _vm.form.agreement,
              callback: function ($$v) {
                _vm.$set(_vm.form, "agreement", $$v)
              },
              expression: "form.agreement",
            },
          }),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n      Dane osobowe nie będą przekazywane podmiotom trzecim, jednakże zgodnie z obowiązującym prawem Administrator/Współadministrator może przekazywać dane podmiotom przetwarzającym je na zlecenie Administratora/ Współadministratora np. na podstawie umów o powierzenie przetwarzania danych osobowych dostawcom usług IT, audytorom, doradcom, oraz na podstawie obowiązujących przepisów prawa podmiotom uprawnionym do uzyskania danych np. sądom lub organom ścigania – tylko gdy wystąpią z żądaniem uzyskania danych osobowych i wskażą podstawę prawną swego żądania. Dane osobowe mogą być także w razie konieczności udostępnione innym podmiotom jeżeli będzie to niezbędne do rozpatrzenia tego zgłoszenia\n    "
            ),
          ]),
          _vm._v(" "),
          _c("IcFormButtons", {
            attrs: {
              sending: _vm.isSending,
              error: _vm.isError,
              message: _vm.errorMessage,
            },
            on: { click: _vm.submit },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }